export function isStructuredUserEmotion(value) {
  if (!value || typeof value !== 'object') return false;

  return (
    typeof value.emotion === 'string' &&
    typeof value.confidence === 'number' &&
    typeof value.intensity === 'number'
  );
}

export function normalizeStructuredUserEmotion(value) {
  if (!isStructuredUserEmotion(value)) return null;

  return {
    emotion: value.emotion.trim().toLowerCase(),
    confidence: value.confidence,
    intensity: value.intensity
  };
}

export function buildUserEmotionWsField(userEmotion) {
  const normalized = normalizeStructuredUserEmotion(userEmotion);
  if (!normalized) return null;

  return { user_emotion: normalized };
}
